import React from 'react';
import {BuutonMenuLateralAA} from './BuutonMenuLateralAA';
import './menuLateralAA.css';

/* A function that returns a JSX element. */
export const MenuLateralAA = (props) => {
	/* Destructuring the props object. */
	const {seleccionado} = props;

	/* An array of objects. */
	let listaBotonesMenuLateralAA = [
		{
			nombre: 'Usuarios',
			clase: 'buttonMenuLateralAA',
			goTo: 'Usuarios',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-person-lines-fill'
					viewBox='0 0 16 16'
				>
					<path d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z' />
				</svg>
			),
		},
		{
			nombre: 'Generar Informes',
			clase: 'buttonMenuLateralAA',
			goTo: 'graficas',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-pie-chart-fill'
					viewBox='0 0 16 16'
				>
					<path d='M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z' />
				</svg>
			),
		},
		{
			nombre: 'Empresas',
			clase: 'buttonMenuLateralAA',
			goTo: 'empresas',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-briefcase'
					viewBox='0 0 16 16'
				>
					<path d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z' />
				</svg>
			),
		},
		{
			nombre: 'Categorias y servicios',
			clase: 'buttonMenuLateralAA',
			goTo: 'categoriasServicios',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-grid'
					viewBox='0 0 16 16'
				>
					<path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z' />
				</svg>
			),
		},
		{
			nombre: 'Tus pacientes',
			clase: 'buttonMenuLateralAA',
			goTo: 'pacientes',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-person-video2'
					viewBox='0 0 16 16'
				>
					<path d='M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
					<path d='M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2ZM1 3a1 1 0 0 1 1-1h2v2H1V3Zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5Zm-4-2h3v2H2a1 1 0 0 1-1-1v-1Zm3-1H1V8h3v2Zm0-3H1V5h3v2Z' />
				</svg>
			),
		},
	];
	/* A function that returns a JSX element. */
	return (
		<div className='menuLateralAA'>
			{listaBotonesMenuLateralAA.map((botonMenuLateralAA, key) =>
				key === seleccionado ? (
					<BuutonMenuLateralAA
						key={key}
						opcion={botonMenuLateralAA.nombre}
						stilo={' buttonMenuLateralAAClick'}
						goTo={botonMenuLateralAA.goTo}
						icon={botonMenuLateralAA.icon}
					/>
				) : (
					<BuutonMenuLateralAA
						key={key}
						opcion={botonMenuLateralAA.nombre}
						stilo={botonMenuLateralAA.clase}
						goTo={botonMenuLateralAA.goTo}
						icon={botonMenuLateralAA.icon}
					/>
				)
			)}
		</div>
	);
};
